/**
 * @fileoverview The summary card grid of the Sales Dashboard.
 * @description Lays out the six cards, three across on a wide screen, each shown only for a section
 * the backend sent (a section the caller may not see is left out, never zeroed).
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import { ActiveClientsCard, SalesTeamCard, UsersCard } from './DashboardPeopleCards'
import { MyPageCard, PerformanceCard, PipelineCard } from './DashboardPipelineCards'

import type { SalesDashboard } from '@/features/sales/types/sales-dashboard.types'

interface DashboardSummaryCardsProps {
  dashboard: SalesDashboard
  canAddUsers: boolean
}

/**
 * @component
 * @param {DashboardSummaryCardsProps} props - The dashboard and whether to offer Add user.
 * @param {SalesDashboard} props.dashboard - The dashboard the backend returned.
 * @param {boolean} props.canAddUsers - Whether the caller may add users.
 */
function DashboardSummaryCards({ dashboard, canAddUsers }: DashboardSummaryCardsProps) {
  const { backlog, myPage, achievement, salesTeam, activeClients, userManagement } = dashboard

  return (
    <section className="grid-cards grid gap-4" data-testid="dashboard-cards">
      {backlog && <PipelineCard backlog={backlog} />}
      {myPage && <MyPageCard myPage={myPage} />}
      {achievement && <PerformanceCard achievement={achievement} />}
      {salesTeam && <SalesTeamCard salesTeam={salesTeam} />}
      {activeClients && <ActiveClientsCard activeClients={activeClients} />}
      {userManagement && <UsersCard userManagement={userManagement} canAddUsers={canAddUsers} />}
    </section>
  )
}

export default DashboardSummaryCards
